export default __webpack_public_path__ + "static/media/Nina_9781408325025.ce59e376.jpg";